import { createApp } from "vue";
import App from "./App.vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import router from "./router";
import store from "./store";
import layer from "@layui/layer-vue";
import "@layui/layer-vue/lib/index.css";
import './assets/iconfont/iconfont.css';

const app = createApp(App);
app.use(ElementPlus);
app.use(router);
app.use(store);
app.use(layer);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.mount("#app");

/**
 * 以下的代码是用来解决element plus ui的一个BUG
 * BUG：ResizeObserver loop completed with undelivered notifications
 */
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}